<template>
    <template v-if="shouldShowTickAndIndustryList">
        <IconCircleCheck class="pt-1 text-green-10 h-6" />
        <AgencyAdvertIndustryList :agency="agency" />
    </template>

    <IconInfo class="text-green-10 h-5 w-5 mt-1" />
    <AgencyAdvertRecruitedFor :agency="agency" />
 
</template>
<script>
import AgencyAdvertIndustryList from 'Components/AgencyAdvertIndustryList.vue';
import AgencyAdvertRecruitedFor from 'Components/AgencyAdvertRecruitedFor.vue';
import IconInfo from 'Components/Icons/IconInfo';
import IconCircleCheck from 'Components/Icons/IconCircleCheck';
import { mapGetters } from 'vuex';

export default {
    name: 'AgencyAdvertStrapline',
    components: { AgencyAdvertIndustryList, AgencyAdvertRecruitedFor, IconInfo, IconCircleCheck },
    props: {
        agency: {},
    },
    computed: {
        ...mapGetters('search', ['shouldShowTickAndIndustryList']),
    }
};
</script>
